import actions from "@/store/modules/organisations/organisation-units/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-units/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
